import { NgModule } from '@angular/core';

import { CustomerActionsComponent }      from './customer.actions.component';
import { CustomerActivityLogsComponent } from './customer.activity-logs.component';
import { CustomersComponent }            from './customers.component';
import { CustomersService }              from './customers.service';
import { CustomerTypePipe }              from './customer.type.pipe';
import { SharedModule }                  from '../shared/shared.module';
import { TableModule }                   from '../table/table.module';

@NgModule({
  declarations: [
    CustomerActionsComponent,
    CustomerActivityLogsComponent,
    CustomersComponent,
    CustomerTypePipe
  ],
  entryComponents: [
    CustomerActionsComponent,
    CustomerActivityLogsComponent,
    CustomersComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    CustomersService,
    CustomerTypePipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'customerType',
      useClass: CustomerTypePipe
    }
  ]
})
export class CustomersModule {}
